import React from "react" ;
import SafeguardingAppBodyHeader from "./SafeguardingAppBodyHeader";
import {Route, Switch} from "react-router-dom";

import {getSafeguardingRouterPath, PATH_SAFEGUARDING_ROOT} from "root/Wieldy/routePaths";
import ScrollRails from "../../Common/Body/ScrollRails";
import SafeguardingTab from "root/Wieldy/ApplicationModules/Safeguarding/Body/SafeguardingTab";
import UsersTab from "root/Wieldy/ApplicationModules/Users/Body/UsersTab";

const SafeguardingAppBody= (props) =>
{
    return (
    <div className="dt-module__container">
        <SafeguardingAppBodyHeader />
        <div className="dt-module__content ps-custom-scrollbar ps" style={{height: props.height, width: props.width}}>
            <div className="dt-module__content-inner">
                <div className="dt-module__list">
                    <Switch>
                        <Route path={getSafeguardingRouterPath('misuse')} render={(thisprops) => <SafeguardingTab resource_id='' {...thisprops}/>}/>
                        <Route path={getSafeguardingRouterPath('blocked')} render={(thisprops) => <UsersTab user_id='' {...thisprops}/>}/>
                        <Route path={PATH_SAFEGUARDING_ROOT} render={(thisprops) => <SafeguardingTab resource_id='' {...thisprops}/>}/>
                    </Switch>
                </div>
            </div>
            <ScrollRails />
        </div>
    </div>
    ) ;
}

export default SafeguardingAppBody;
